import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const MatchedPlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  padding: 7px 10px;
  border: 1px solid ${Color.Grey200};
  border-radius: 4px;
  position: relative;
  background-color: ${Color.Grey100};

  & > *:not(:first-of-type) {
    margin-left: 20px;
  }
`

interface MatchedPlaceholderOverlayProps {
  isDraggingOver?: boolean
}

export const MatchedPlaceholderOverlay = styled.div<MatchedPlaceholderOverlayProps>`
  height: 30px;
  border: ${({ isDraggingOver }) => (isDraggingOver ? '1px dashed #CFCFCF' : 'initial')};
  border-radius: 4px;
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  background: ${({ isDraggingOver }) =>
    isDraggingOver
      ? 'linear-gradient(90deg, #F5FBFF, #F5FBFF, #F5FBFF)'
      : 'linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.5), rgba(255,255,255,1.0))'};
  transition: background 0.2s;
`
